import { useCallback, useEffect } from 'react'
import isEqual from 'lodash/isEqual'
import { BusinessAccountDirectionEnum } from '@medentee/enums'

import {
  getOrganizationRegisteredUsersRequest,
  useAppDispatch,
  useAppSelector,
  createLoadingSelector,
  GET_ORGANIZATION_REGISTERED_USERS,
  getOrganizationsInvitationsFiltersSelector
} from 'store'
import { List } from 'App/components/Organizations/OrganizationInvitations/List'

const loadingSelector = createLoadingSelector([GET_ORGANIZATION_REGISTERED_USERS])

export const OrganizationInvitationsRegistered = () => {
  const dispatch = useAppDispatch()
  const ids = useAppSelector(
    (state) => state.organizations.invitations.registeredUsers.ids,
    isEqual
  )
  const total = useAppSelector((state) => state.organizations.invitations.registeredUsers.total)
  const loading = useAppSelector(loadingSelector)
  const { current, showBy } = useAppSelector(getOrganizationsInvitationsFiltersSelector, isEqual)

  const handlePaginationChange = useCallback(
    (page: number) => {
      dispatch(
        getOrganizationRegisteredUsersRequest({
          current: page,
          showBy,
          direction: BusinessAccountDirectionEnum.OUTGOING
        })
      )
    },
    [dispatch, showBy]
  )

  useEffect(() => {
    dispatch(
      getOrganizationRegisteredUsersRequest({ direction: BusinessAccountDirectionEnum.OUTGOING })
    )
  }, [dispatch])

  return (
    <List
      ids={ids}
      type="registered"
      loading={loading}
      pagination={{
        total,
        current,
        showBy,
        onChange: handlePaginationChange
      }}
    />
  )
}
